/** Прод-домен интерфейса. Нужен, чтобы временно прятать на проде то, что уже есть на стейджинге
 *  (Алексей 08.10: «скрой на проде панель Статус пока что»). */
export const PROD_HOST = 'my.linzametrics.com';

export function isProdHost(): boolean {
  return typeof window !== 'undefined' && window.location.hostname === PROD_HOST;
}
